import { UnifiedAlarm } from '@hakimo-ui/hakimo/types';
import {
  getEnterpriseAlarmDetails,
  getEnterpriseFieldRows,
} from '../unified-alarm-group/utils';

interface Props {
  alarm: UnifiedAlarm;
  alarmType?: string;
  location?: string;
}

export function AlarmInfoCard({ alarm, alarmType, location }: Props) {
  const { alarmSourceSystem, employee } = getEnterpriseAlarmDetails(alarm);
  // Pass only the 4 fields this card displays — the rest remain undefined
  // and are filtered out by getEnterpriseFieldRows, giving us a subset
  // without magic-string filtering.
  const rows = getEnterpriseFieldRows(
    { alarmType, alarmSourceSystem, employee },
    { location }
  );

  if (rows.length === 0) {
    return (
      <div className="text-ondark-text-2 flex h-full w-full items-center justify-center p-3 text-center text-xs">
        No alarm details available
      </div>
    );
  }

  return (
    <div className="flex h-full w-full min-w-0 items-center justify-center px-6 py-4">
      <dl className="mx-auto grid w-full max-w-full grid-cols-1 justify-items-stretch gap-x-8 gap-y-4 sm:grid-cols-2">
        {rows.map(({ label, value }) => (
          <div
            key={label}
            className="flex w-full min-w-0 flex-col items-center px-4 sm:px-6"
          >
            <dt className="text-ondark-text-2 text-center text-[10px] font-medium uppercase tracking-wide">
              {label}
            </dt>
            <dd className="text-ondark-text-1 mt-0.5 whitespace-normal break-words text-center text-sm leading-snug">
              {value}
            </dd>
          </div>
        ))}
      </dl>
    </div>
  );
}

export default AlarmInfoCard;
